import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableHeader, TableRow, TableBody, TableRowColumn, RaisedButton,
  Paper,
  Card,
  CardText,
  TableHeaderColumn,
  TableFooter,
  CircularProgress,
} from "material-ui";
import styles from "../../styles/styles";
import TablePaginationCustom from "../../TablePagination/view";

class DetalleErroresSE extends React.Component {
  componentWillMount() { }

  render() {
    const listErrores = [];
    this.props.errores.forEach((error, index) => {
      listErrores.push((
        <TableRow style={{ backgroundColor: "#f7dcdd" }} key={`TableRowErrores_${index}`}>
          <TableRowColumn style={{ width: 75 }}>
            <i className="material-icons">clear</i>
          </TableRowColumn>
          <TableRowColumn style={{ width: 50, padding: 1, whiteSpace: "normal" }}>
            {error.Fila === null ? "-" : (error.Fila + 2)}
          </TableRowColumn>
          <TableRowColumn style={{ width: 60, padding: 1, whiteSpace: "normal" }}>
            {error.Columna === null ? "-" : (error.Columna)}
          </TableRowColumn>
          <TableRowColumn style={{ whiteSpace: "normal" }}>
            {error.Errores}
          </TableRowColumn>
        </TableRow>
      ));
    });
    return (

      <div style={{ width: "100%", fontSize: "13px" }}>
        <Card zDepth={0} style={{ padding: 0 }}>
          <CardText style={{ paddingBottom: 0 }}>
            <div className="row" style={{ paddingBottom: 0 }}>
              <div className="col-12">
                <Paper zDepth={1} rounded={false} width="100%" style={{ margin: "10px 0px", width: "100%", padding: "10px 5px" }} >
                  <div className="col-12" style={{ margin: 0, padding: 0 }}>
                    <div style={styles.h1}>Solicitud Especial
                    </div>
                  </div>
                  <div className="col-12" style={{ margin: "10px 0px", padding: 0 }}>
                    <div style={styles.h3}>
                      La solicitud presenta los siguientes errores y no se pudo procesar
                    </div>
                  </div>

                  <div style={{ marginTop: 10 }}>
                    {this.props.loadingErrores ?
                      <CircularProgress></CircularProgress>
                      :
                      <Table
                        selectable={false}
                        multiSelectable={false}
                        style={{ width: 1000, margin: "auto" }}
                      >
                        <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                          <TableRow selectable={false}>
                            <TableHeaderColumn style={{ width: 75 }}></TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 40, padding: 1 }}>Fila</TableHeaderColumn>
                            <TableHeaderColumn style={{ width: 60, padding: 1 }}>Columna</TableHeaderColumn>
                            <TableHeaderColumn>Error</TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false} id="tablaBodyGrillaErrores">
                          {listErrores}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TableRowColumn>
                              <TablePaginationCustom
                                key={`pag_tablaBodyGrillaErrores_${listErrores.length}`}
                                rowsPerPageDefault={5} // [5,10,15,20,25]
                                totalRows={listErrores.length}
                                pageDefault={1}
                                idTableBody="tablaBodyGrillaErrores"
                                showRowsPerPage={false}
                                labelStyleBtnPage={{ fontSize: "11px" }}
                                overlayStyleBtnPage={{ borderRadius: 20 }}
                                rippleStyleBtnPage={{ borderRadius: 20 }}
                                buttonStyleBtnPage={{ borderRadius: 20 }}
                                styleBtnPage={{
                                  paddingLeft: 0,
                                  paddingRight: 0,
                                  paddingTop: 0,
                                  paddingBottom: 0,
                                  height: 25,
                                  width: "45px",
                                  minWidth: "45px",
                                  borderRadius: 20,
                                  marginRight: 5,
                                }}

                                labelStyleRowsPerPage={styles.h4}
                                underlineStyleRowsPerPage={styles.underlineSelectField}
                                iconStyleRowsPerPage={styles.iconSelectField}
                                menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                                selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                                styleRowsPerPage={styles.selectFiledStyle}
                              />
                            </TableRowColumn>
                          </TableRow>
                        </TableFooter>
                      </Table>
                    }

                    <div className="row" style={{ paddingTop: 10 }}>
                      <div className="col-3">
                        <RaisedButton
                          label="Volver"
                          onClick={() => this.props.closeModal()}
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                        />
                      </div>
                    </div>
                  </div>
                </Paper>
              </div>
            </div>
          </CardText>
        </Card>
      </div>


    );
  }
}

DetalleErroresSE.defaultProps = {
};

DetalleErroresSE.propTypes = {
  errores: PropTypes.array.isRequired,
  loadingErrores: PropTypes.bool.isRequired,
  // dispatch: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errores: state.filtroBusquedaSE.errores,
  loadingErrores: state.filtroBusquedaSE.loadingErrores,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DetalleErroresSE);



// WEBPACK FOOTER //
// ./src/components/SolicitudesEspeciales/GrillaSolicitudes/DetalleErrores.jsx